import { getRequiredDateFormat } from '../../../utils/date/date-format';

export const initialState: any = {
  date: getRequiredDateFormat(new Date(), 'YYYY-MM-DDTHH:mm:ssZ'),
  parametersList: { devices: [], incident_types: [], severities: [] },
};
